import { render, staticRenderFns } from "./OrgLeaderboardBranchView.vue?vue&type=template&id=748d297a&scoped=true&"
import script from "./OrgLeaderboardBranchView.vue?vue&type=script&lang=js&"
export * from "./OrgLeaderboardBranchView.vue?vue&type=script&lang=js&"
import style0 from "./OrgLeaderboardBranchView.vue?vue&type=style&index=0&id=748d297a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748d297a",
  null
  
)

export default component.exports